export default "__VITE_ASSET__2rIip1NE__"